import clsx from 'clsx';
import { InnerHTML } from '@headless-workspace/domain/common/client';
import { KitAdditionalContentsValue } from '@headless-workspace/domain/common/server';
import { PropsWithFontFamily, typographyStyle } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ProductKitDescriptionProps = PropsWithFontFamily & {
    info: KitAdditionalContentsValue['value'];
};

export const ProductKitDescription: Component<ProductKitDescriptionProps> = ({ info, fontFamily }) => {
    return (
        <div className={clsx('kit-content', typographyStyle({ fontFamily }))}>
            <InnerHTML rawHtml={{ content: info?.title ?? '' }} />
            <br />
            <InnerHTML rawHtml={{ content: info?.description ?? '' }} />
        </div>
    );
};
